// extracted by mini-css-extract-plugin
export default {"monitor":"monitor-monitor-XhtFMB","menusHidden":"monitor-menusHidden-vhSjm_"};